const altText =
  'Du må være abonnent for å lese videre. Kjøp abonnement ved å klikke på "Bli abonnent" i toppen av siden. Allerede abonnent? Logg inn via menyen i toppen av siden.';

const imgBaseUrl = '/seksjon/dist/img/salesposter-fallback';

const fallbackContent = `
<p style="text-align:center;margin:20px auto;">
  <picture>
    <source media="(max-width: 740px)" srcset="${imgBaseUrl}/320x250.png 1x, ${imgBaseUrl}/320x250@2x.png 2x" />
    <source media="(max-width: 980px)" srcset="${imgBaseUrl}/650x250.png 1x, ${imgBaseUrl}/650x250@2x.png 2x" />
    <img alt="${altText}" style="max-width: 100%" src="${imgBaseUrl}/700x250.png" srcset="${imgBaseUrl}/700x250.png 1x, ${imgBaseUrl}/700x250@2x.png 2x" />
  </picture>
</p>`;

export const fallbackPoster = {
  campaign: 'fallback_campaign',
  contentName: 'fallback_content',
  content: fallbackContent,
};
